import merge from 'lodash/merge';

import { FORM_FACTORS } from '../constants';
import { TFullPage, TPage, TPages } from '../types';

import getMatchedPathFromBatch from './getMathedPathFromBatch';

export const getPage = (page: TFullPage, formFactor: string) => {
  const { general = {} } = page || {};

  const result =
    formFactor && page[formFactor]
      ? page[formFactor]
      : page[FORM_FACTORS.MOBILE];

  // merge is mutating all page object and crash page rebuild by formFactor.
  // need to make clone of resulting object without mutation
  return merge({}, general, result);
};

const getPageConfig = (
  pathname: string,
  formFactor: string,
  pages: TPages
): [string, TPage] | null => {
  const matchedPath = getMatchedPathFromBatch(pages, pathname);
  if (matchedPath && pages[matchedPath]) {
    const page = pages[matchedPath];

    return [matchedPath, getPage(page, formFactor)];
  }
  return null;
};

export default getPageConfig;
